import React from 'react';
import './FormInput.css';

const DosInput = ({ value, onChange }) => {
  return (
    <div className="form-input-group">
      <label className="form-label">Do's</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="form-textarea"
        placeholder="List requirements or things to do"
        rows="4"
      />
    </div>
  );
};

export default DosInput;

